import { Link } from 'react-router-dom'

export function Footer() {
	const year = new Date().getFullYear()
	return (
		<footer className="bg-gray-50 border-t">
			<div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
				<div className="flex flex-col items-center justify-between space-y-4 sm:flex-row sm:space-y-0">
					<div className="flex items-center space-x-2">
						<div className="h-6 w-6 rounded-lg bg-zcash-500 flex items-center justify-center">
							<span className="text-white font-bold text-xs">S</span>
						</div>
						<span className="text-sm text-gray-600">
							© {year} Secresea.com — Private NFT Marketplace
						</span>
					</div>

					<div className="flex space-x-6 text-sm text-gray-500">
						<Link to="/privacy" className="hover:text-gray-900">
							Privacy
						</Link>
						<Link to="/terms" className="hover:text-gray-900">
							Terms
						</Link>
						<Link to="/how-it-works" className="hover:text-gray-900">
							How it works
						</Link>
						<Link to="/docs" className="hover:text-gray-900">
							Docs
						</Link>
						<Link to="/docs/standard" className="hover:text-gray-900">
							ZINC standard
						</Link>
						<Link to="/bridge" className="hover:text-gray-900">
							Bridge
						</Link>
					</div>
				</div>
			</div>
		</footer>
	)
} 